import React from 'react';

const ClockServicesIcon = ({ width = 18, height = 18, fill = '#CE181E', className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.0013 0.66748C4.41797 0.66748 0.667969 4.41748 0.667969 9.00081C0.667969 13.5841 4.41797 17.3341 9.0013 17.3341C13.5846 17.3341 17.3346 13.5841 17.3346 9.00081C17.3346 4.41748 13.5846 0.66748 9.0013 0.66748ZM11.9596 12.1675L8.55964 10.0758C8.30964 9.92581 8.15964 9.65915 8.15964 9.36748V5.45915C8.16797 5.11748 8.4513 4.83415 8.79297 4.83415C9.13464 4.83415 9.41797 5.11748 9.41797 5.45915V9.16748L12.618 11.0925C12.918 11.2758 13.018 11.6675 12.8346 11.9675C12.6513 12.2591 12.2596 12.3508 11.9596 12.1675Z"
        fill={fill}
      />
    </svg>
  );
};

export default ClockServicesIcon;
